import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";

import Spinner from "../../../../../components/common/Spinner";
import styles from "./styles.module.scss";

const MAX_CHARS = 500;

interface RejectSettlementModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  rejectionComment: string;
  setRejectionComment: (value: string) => void;
}

const RejectSettlementModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  rejectionComment,
  setRejectionComment,
}: RejectSettlementModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} className={styles.overlay}>
      <div className={styles.modal}>
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          ✕
        </button>
        <div className={styles.header}>
          <h2 className={styles.title}>{t("lbl_confirm_reject_settlement")}</h2>
          <p className={styles.desc}>{t("lbl_reject_settlement_reason_prompt")}</p>
        </div>
        <div className={styles.inputField}>
          <div className={styles.textareaWrapper}>
            <textarea
              className={styles.textarea}
              value={rejectionComment}
              onChange={(e) => setRejectionComment(e.target.value)}
              placeholder={t("lbl_rejection_comment_placeholder")}
              maxLength={MAX_CHARS}
            />
          </div>
          <div className={styles.charCount}>
            <span className={styles.charMax}>{MAX_CHARS}</span>
            <span className={styles.charSep}>/</span>
            <span className={styles.charCurrent}>{rejectionComment.length}</span>
          </div>
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.confirmBtn}
            disabled={!rejectionComment.trim() || loading}
            onClick={onConfirm}>
            {loading ? <Spinner /> : t("lbl_confirm_reject")}
          </button>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={onClose}>
            {t("lbl_cancel")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RejectSettlementModal;
